import styled from "styled-components";

export const TableRowWrapper = styled.div`
  /* border: 1px solid black; */
  display: grid;
  grid-template-areas: "PurchasedDate Description TotalCostContainer Status Receipt CancelOrRefund";
  grid-template-columns: 90px 120px 70px 105px auto auto;
  /* border: 1px solid black; */
  column-gap: 10px;
  font-size: 13px;
  // padding: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  @media screen and (max-width : 440px){
    grid-template-columns: 52px 60px 40px 50px auto auto;
  }
  @media screen and (max-width : 320px){
    grid-template-columns: 35px 60px 35px 35px auto auto;
  }
`;

export const PurchasedDate = styled.div`
  grid-area: PurchasedDate;
  width : 90px;
  /* border: 1px solid black; */
  @media screen and (max-width : 440px){
    font-size: .7rem;
    width : 52px;
  }
  @media screen and (max-width : 320px){
    width : 35px;
  }
`;
export const Description = styled.div`
  grid-area: Description;
  /* border: 1px solid black; */
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
  width : 120px;
  @media screen and (max-width : 440px){
    font-size: .7rem;
    width : 60px;
  }
  @media screen and (max-width : 320px){
    width : 60px;
  }
`;

export const TotalCostContainer = styled.div`
  grid-area: TotalCostContainer;
  /* border: 1px solid black; */
  display: flex;
  width : 70px;
  justify-content: center;
  align-items : center;
  
  @media screen and (max-width : 440px){
    font-size: .7rem;
    width : 40px;
  }
  @media screen and (max-width : 320px){
    width : 35px;
  }
`;
export const Currency = styled.div`
  /* border: 1px solid black; */
  width: 12px;
  margin-right: 2px;
  @media screen and (max-width : 440px){
    font-size: .7rem;
  }
`;
export const TotalCost = styled.div`
  /* border: 1px solid black; */
  @media screen and (max-width : 440px){
    font-size: .7rem;
  }
`;
export const PaymentMethod = styled.div`
  grid-area: PaymentMethod;
  width : 105px;
  /* border: 1px solid black; */
  @media screen and (max-width : 440px){
    font-size: .7rem;
    width : 50px;
  }
  @media screen and (max-width : 320px){
    width : 35px;
  }
`;
export const Status = styled.div`
  grid-area: Status;
  width : 105px;
  /* border: 1px solid black; */
  @media screen and (max-width : 440px){
    font-size: .7rem;
    width : 50px;
  }
  @media screen and (max-width : 320px){
    width : 35px;
  }
`;
export const Receipt = styled.div`
  grid-area: Receipt;
  border: 1px solid #1fbdcb;
  color: #1fbdcb;
  border-radius: 5px;
  /* padding : 0 .3rem; */
  cursor: pointer;
  visibility: ${props => props.isHidden ? "hidden" : "inherit"};
  &:hover{
    border: 1px solid #1fbdcb;
    background : #1fbdcb;
    color: #fff;
  }
  @media screen and (max-width : 440px){
    font-size: .4rem;
  }
`;

export const CancelOrRefund = styled.div`
  grid-area: CancelOrRefund;
  border: 1px solid #1fbdcb;
  color: #1fbdcb;
  border-radius: 5px;
  cursor: pointer;
  visibility: ${props => props.isHidden ? "hidden" : "inherit"}; 
  /* max-width : 105px; */
  /* padding : 0 .3rem; */
  @media screen and (max-width : 440px){
    font-size: .4rem;
  }
`;